import { useCallback, useState } from 'react'

import type { AdvancedFilters } from '../model/types'

const EMPTY_FILTERS: AdvancedFilters = {
  place: null,
  speaker: null,
  kind: null
}

/**
 * Estado dos filtros avançados do schedule.
 * Cada filtro é independente; `reset` limpa todos de uma vez.
 */
export const useScheduleFilters = () => {
  const [filters, setFilters] = useState<AdvancedFilters>(EMPTY_FILTERS)

  const setPlace = useCallback((place: string | null) => {
    setFilters(prev => ({ ...prev, place }))
  }, [])

  const setSpeaker = useCallback((speaker: number | null) => {
    setFilters(prev => ({ ...prev, speaker }))
  }, [])

  const setKind = useCallback((kind: string | null) => {
    setFilters(prev => ({ ...prev, kind }))
  }, [])

  const reset = useCallback(() => {
    setFilters(EMPTY_FILTERS)
  }, [])

  const hasActiveFilters = Boolean(filters.place || filters.speaker || filters.kind)

  return {
    filters,
    setPlace,
    setSpeaker,
    setKind,
    reset,
    hasActiveFilters
  }
}
